<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div style="margin-top: 2%">
       

        <v-card>
            <v-card-title>

                <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Rechercher un client ..."
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                                   :headers="headers"
                                   :items="userclients"
                                   :search="search"
                                   sort-by="name"
                                   class="elevation-1"
                                   :loading="userclients==undefined" loading-text="Chargement en cours...">

                                    <template v-slot:item.created_at="{item}">
                                        {{ getformatDate(item.created_at)}}
                                    </template>

                               <template v-slot:no-data>
                                   <v-btn color="default" @click="initialize">Actualiser</v-btn>
                               </template>

                           </v-data-table>
        </v-card>

        <v-snackbar
                v-model="snackbar"
                timeout="2000"
        >
            {{ textSnack }}

            <template v-slot:action="{ attrs }">
                <v-btn
                        color="blue"
                        text
                        v-bind="attrs"
                        @click="snackbar = false"
                >
                    Fermer
                </v-btn>
            </template>
        </v-snackbar>


    </div>
</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import helpers from "../mixins/helpers";

     export default {
        name: "User",
        mixins:[helpers(this)],
        data() {
            return {
                submitting: false,
                valid: true,
                lazy: false,
                errors:undefined,
                search: '',
                dialog: '',
                id: undefined,
                snackbar: false,
                user: JSON.parse(localStorage.getItem("user")),
                textSnack: '',
                show1: false,
                headers: [
                    {
                        text: 'Nom complet',
                        align: 'start',
                        sortable: true,
                        value: 'name',
                    },
                    {text: 'Email', value: 'email'},
                    {text: 'Date', value: 'created_at'}
                ],
                editedIndex: -1,
                editedItem: {
                    password: '',
                    email: '',
                    name: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    password: '',
                    email: '',
                    name: '',
                    _id: 0,
                    created_at: 0,
                },
                nameRules: [
                    v => !!v || 'Nom requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                emailRules: [
                    v => !!v || 'Email requis',
                ]
                ,
                passwordRules: [
                   v => !!v || 'Mot de passe requis',
                ]

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvel utilisateur" : "Mise à jour"
            }
            ,
            ...mapState('users/', ['userclients'])

        }
        ,
        mounted() {
           
            this.$store.dispatch('users/getByType',"client").then(response => {
                window.console.log('users', response)
            });
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            }
            ,

            editItem(item) {
                this.editedIndex = this.users.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.editedItem.password='';
                this.dialog = true;
            }
            ,

            deleteItem(item) {
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: "Êtes vous sûr(e) de vouloir supprimé ce élement?",
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('users/deleteUser', item._id).then((result) => {
                            console.log("del");
                            console.log(result);
                            this.snackbar = true;
                            this.textSnack = result.data.message;
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: result.data.message,
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            save() {
                this.submitting = true;
                let data = new FormData();
                data.append("email", this.editedItem.email);
                data.append("name", this.editedItem.name);
                data.append("password", this.editedItem.password);
                let mineroute = 'users/setUser';
                if (this.editedIndex>-1){
                    data.append("id",this.editedItem._id);
                    mineroute = 'users/setUpdateUser';
                }
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.submitting = false;
                    if (response.error) {
                        this.errors.operation = response.data.message;
                    } else {
                        this.close();
                    }
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>